"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ProductOverviewComponent = _interopRequireDefault(require("./ProductOverviewComponent"));

var _utils = require("../../../../../configuration/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ExternalBanner = function ExternalBanner(_ref) {
  var setBannerHeight = _ref.setBannerHeight,
      bannerHeight = _ref.bannerHeight,
      externalHtmlBanner = _ref.externalHtmlBanner,
      selectedFilters = _ref.selectedFilters,
      flexSpotBanner = _ref.flexSpotBanner;

  var getHeight = function getHeight(e) {
    if (e && bannerHeight !== e.offsetWidth) {
      setTimeout(function () {
        setBannerHeight(function (prev) {
          return prev !== e.offsetWidth ? e.offsetWidth : prev;
        });
      }, 400);
    }
  };

  var customGAEvent = function customGAEvent() {
    (0, _utils.sendDataLayerEvent)("Marketing banner", selectedFilters ? "".concat(selectedFilters[0].dataKey, ": ").concat(selectedFilters[0].value) : "default");
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, flexSpotBanner ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "products__banner flex-spot-banner",
    onClick: customGAEvent,
    ref: getHeight,
    style: {
      height: bannerHeight + "px"
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "background-container fade-in animated delay-1s",
    href: flexSpotBanner.link,
    style: {
      backgroundImage: "url(".concat(flexSpotBanner.imageSrc, ")")
    },
    tabIndex: "5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-container",
    dangerouslySetInnerHTML: {
      __html: flexSpotBanner.html || ""
    }
  }))) : externalHtmlBanner && /*#__PURE__*/_react["default"].createElement("div", {
    className: "products__banner",
    onClick: customGAEvent,
    ref: getHeight,
    style: {
      height: bannerHeight + "px"
    },
    dangerouslySetInnerHTML: {
      __html: externalHtmlBanner
    }
  }));
};

var ExternalBannerContainer = function ExternalBannerContainer(_ref2) {
  var setBannerHeight = _ref2.setBannerHeight,
      bannerHeight = _ref2.bannerHeight,
      setBannerProducts = _ref2.setBannerProducts,
      products = _ref2.products,
      isAccessoriesList = _ref2.isAccessoriesList;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      externalHtmlBanner = _useState2[0],
      setExternalHtmlBanner = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      smallProducts = _useState4[0],
      setSmallProducts = _useState4[1];

  var _useState5 = (0, _react.useState)((0, _utils.findFlexSpotExternalBannerData)()),
      _useState6 = _slicedToArray(_useState5, 1),
      flexSpotElements = _useState6[0];

  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var selectedFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedFilters;
  });
  (0, _react.useEffect)(function () {
    var smallProductsArr = [];

    if (products) {
      if (products.length > 3 && !isAccessoriesList && (findExternalBanner() || flexSpotElements) && selectedFilters.length === 1) {
        smallProductsArr.push(products[2]);
        smallProductsArr.push(products[3]);
        setSmallProducts(smallProductsArr);
        setBannerProducts(smallProductsArr);
      } else {
        setSmallProducts(null);
        setBannerProducts(null);
      }
    }
  }, [products]);

  var findExternalBanner = function findExternalBanner() {
    var lastClicked = selectedFilters.length ? selectedFilters[selectedFilters.length - 1] : null;
    var $banner = lastClicked && document.querySelector(".intro-banner.".concat(lastClicked.value.replace(/\s/g, "").toLowerCase(), ".").concat(lastClicked.dataKey)) ? document.querySelector(".intro-banner.".concat(lastClicked.value.replace(/\s/g, "").toLowerCase(), ".").concat(lastClicked.dataKey)) : document.querySelector(".intro-banner.product-list-banner.default-banner");

    if ($banner) {
      setExternalHtmlBanner($banner.outerHTML);
      return true;
    } else {
      setExternalHtmlBanner(null);
      return false;
    }
  };

  var findFlexSpotBanner = function findFlexSpotBanner(banners) {
    var lastClicked = selectedFilters.length ? selectedFilters[selectedFilters.length - 1] : null;

    if (lastClicked !== null && lastClicked !== void 0 && lastClicked.value && banners.length > 0) {
      var banner = banners.filter(function (banner) {
        return banner.tag && (banner.tag.toLowerCase().indexOf(lastClicked.value.toLowerCase()) > -1 || banner.tag.toLowerCase().indexOf(lastClicked.dataKey.toLowerCase()) > -1);
      });
      return banner[0] || null;
    }

    return null;
  };

  var flexSpotBanner = flexSpotElements ? findFlexSpotBanner(flexSpotElements) : null;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, smallProducts && /*#__PURE__*/_react["default"].createElement(ExternalBanner, {
    setBannerHeight: setBannerHeight,
    bannerHeight: bannerHeight,
    externalHtmlBanner: externalHtmlBanner,
    setExternalHtmlBanner: setExternalHtmlBanner,
    selectedFilters: selectedFilters,
    flexSpotBanner: flexSpotBanner
  }), smallProducts && /*#__PURE__*/_react["default"].createElement("div", {
    className: "products__small"
  }, smallProducts.map(function (product, index) {
    return /*#__PURE__*/_react["default"].createElement(_ProductOverviewComponent["default"], {
      product: product,
      key: index,
      index: index,
      dictionary: dictionary,
      isAccessoriesList: false,
      lazyLoad: false,
      isMobile: null,
      isRouter: true
    });
  })));
};

var _default = ExternalBannerContainer;
exports["default"] = _default;